import { render, staticRenderFns } from "./XdataUpdateRowControl.vue?vue&type=template&id=1d4c639d&"
import script from "./XdataUpdateRowControl.vue?vue&type=script&lang=js&"
export * from "./XdataUpdateRowControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports